import PurchaseInvoice from "./PurchaseInvoice";


const PurchaseInvoiceConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  routes: [
    {
      path: '/purchaseInvoice',
      element: <PurchaseInvoice />,
    },
    
  ],
};

export default PurchaseInvoiceConfig;
